<app-loader *ngIf="isLoading"></app-loader>
<div class="opd-header">
    <div class="opd-header-left">
        <div class="patient-header-left">
            <i-tabler name="arrow-left" class="icon-20 cursor-pointer" (click)="goBack()"></i-tabler>
            <div class="patient-avatar-container">
                <img class="patient-avatar" [src]="profileImagePathSrc" alt="Patient avatar"
                    fallbackImage="assets/images/profile/user-1.jpg" />
            </div>

            <div class="patient-info-block">
                <h4 class="patient-name m-0" *ngIf="OpdData" (click)="viewPatientDetails(patientinfo)">{{
                    OpdData.patientName }} ({{OpdData.patientNumber}})</h4>
                <div class="patient-meta" *ngIf="patientinfo">
                    <span class="patient-age">{{patientinfo.age}}</span>
                    <span class="patient-gender-badge" *ngIf="patientinfo.gender"
                        [ngClass]="patientinfo.gender === 'M' ? 'male' : 'female'">
                        {{getGenderName(patientinfo.gender)}}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="opd-header-middle" *ngIf="OpdData || doctorDetails">
        <div class="opd-inline-stats">
            <div class="opd-info-item" *ngIf="OpdData">
                <span class="opd-label">{{ 'LABEL.OPD_NO' | translate }}</span>
                <span class="opd-value">{{ OpdData.opdNumber }}</span>
            </div>
            <div class="opd-info-item" *ngIf="OpdData">
                <span class="opd-label">{{ 'LABEL.OPD_DATE' | translate }}</span>
                <span class="opd-value">{{ OpdData.opdDate | date: 'dd-MM-yyyy' }}</span>
            </div>
            <div class="opd-info-item" *ngIf="doctorDetails">
                <span class="opd-label">{{ 'LABEL.DOCTOR' | translate }}</span>
                <span class="doctor-value">Dr. {{doctorDetails.firstName}}
                    {{doctorDetails.lastName}}</span>
            </div>
        </div>
    </div>

    <div class="opd-header-right">
        <div class="opd-header-actions">
            <button mat-flat-button color="primary" *ngIf="isAppointmentAttended && isIPD && OpdData?.ipdId"
                (click)="admitToIpd()" class="p-x-16">
                {{ 'ENTITY.IPD' | translate }}
            </button>
            <button mat-flat-button color="primary" *ngIf="isAppointmentAttended && isIPD && !OpdData?.ipdId"
                (click)="admitToIpd()" class="p-x-16">
                {{ 'BUTTON.BTN_CONVERT_TO_IPD' | translate }}
            </button>
            <button mat-stroked-button color="primary" class="p-x-16 border-primary text-primary" (click)="OnBillOPD()">
                {{ 'ENTITY.BILL' | translate }}
            </button>
            <button mat-stroked-button color="warn" *ngIf="!isAppointmentAttended" (click)="finishOPD()"
                class="p-x-16 border-warn text-warn">
                {{ 'BUTTON.BTN_CLOSE_OPD' | translate }}
            </button>
        </div>
    </div>
</div>
<mat-card class="cardWithShadow overflow-hidden border-none">
    <!-- Header Section -->
    <!-- Horizontal Tabs -->
    <div class="bg-white border-bottom p-x-24">
        <div class="d-flex gap-32">
            @for(sidemenu of ListOfSideMenu; track sidemenu.name) {
            <div class="p-y-16 cursor-pointer position-relative tab-item"
                [class.active]="sidemenu.link === selectedComponent" (click)="selectedtab(sidemenu.link)">
                <span class="f-w-600 f-s-14" [class.text-primary]="sidemenu.link === selectedComponent"
                    [class.text-muted]="sidemenu.link !== selectedComponent">{{ sidemenu.name }}</span>
                <div class="active-indicator bg-primary" *ngIf="sidemenu.link === selectedComponent"></div>
            </div>
            }
        </div>
    </div>

    <!-- Content Area -->
    <div class="min-h-600">
        <div class="d-flex justify-content-between align-items-center flex-wrap m-t-10 m-l-20 m-r-10"
            *ngIf="OpdData && categoryTabs.has(selectedComponent)">
            <span class="bg-light-primary text-primary rounded f-w-600 p-x-6 p-y-2 f-s-12">
                <strong class="fst-italic">{{ 'LABEL.NOTE' | translate }}:</strong>
                {{ 'LABEL.CLINICAL_NOTE' | translate }}
            </span>
            <button mat-flat-button color="primary" class="p-10 m-sm-0 d-flex align-items-center"
                (click)="caseHistory.onItemAdd()">
                <mat-icon class="m-r-5">add</mat-icon>
                {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.CLINICALITEM' | translate }}
            </button>
        </div>

        <ng-container *ngIf="selectedComponent !== 'Prescription' && selectedComponent !== 'PatientReport'">
            <app-casehistory #caseHistory *ngIf="OpdData" [selectedtab]="selectedComponent"
                [opdId]="OpdData.id"></app-casehistory>
        </ng-container>

        <ng-container *ngIf="selectedComponent === 'Prescription'">
            <mat-card-content class="prescription-container p-0">
                <app-prescription [patientData]="patientinfo" [doctorData]="doctorDetails"
                    [opdDeatils]="OpdData"></app-prescription>
            </mat-card-content>
        </ng-container>

        <ng-container *ngIf="selectedComponent === 'PatientReport'">
            <mat-card-content class="prescription-container p-0">
                <app-report-print [appointmentData]="appointmentData" [OpdData]="OpdData">
                </app-report-print>
            </mat-card-content>
        </ng-container>
    </div>
</mat-card>